// extracted by mini-css-extract-plugin
export var chevronIcon = "_cl-2";
export var teamName = "_cl-1";
export var teamSwitcherButton = "_cl-0";